import { createGlobalStyle } from "styled-components";

/* Poppins: load once in index.html; stack matches theme/antd-theme.ts and --font-family-app */
export const GlobalStyle = createGlobalStyle`
  * {
    font-family: var(--font-family-app);
    box-sizing: border-box;
  }

  html, body, #root {
    height: 100%;
    margin: 0;
    padding: 0;
  }

  body {
    font-family: var(--font-family-app);
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background: #f5f5f5;
  }
`;
